import {Decoder, equal} from 'json-bouncer'

export type Cis2UserRole = 'Admin'

export function cis2UserRoleDecoder(): Decoder<Cis2UserRole> {
    const admin: Cis2UserRole = 'Admin'
    return equal(admin)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/Cis2UserRole.ts